import { Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { Measure } from 'services/model/model.service';
import { measureHasExpectedLabel } from './expectedLabelMeasures';

export function InfoContentItem({
  titleId = undefined,
  title = undefined,
  descriptionId = undefined,
  description = undefined,
  highlighted = false,
  measure = undefined,
}: {
  titleId?: string;
  title?: string;
  descriptionId?: string;
  description?: string;
  highlighted?: boolean;
  measure?: Measure;
}) {
  const titleNode = titleId ? <FormattedMessage id={titleId} /> : title;
  const descriptionNode = descriptionId ? <FormattedMessage id={descriptionId} /> : description;
  const showExpectedSuffix = highlighted && measure ? measureHasExpectedLabel(measure) : false;

  return (
    <>
      <div className={highlighted ? 'bg-denim-50 px-2' : 'bg-snow-100 px-2'}>
        <Typography variant="body1" sx={{ mb: 3, fontWeight: 400 }}>
          {titleNode}
          {showExpectedSuffix && (
            <>
              {' '}
              <FormattedMessage id="model.measure.modifier.expected" />
            </>
          )}
        </Typography>
      </div>

      <div className="px-2">
        <Typography variant="body2" sx={{ mb: 3, fontWeight: 300 }}>
          {descriptionNode}
        </Typography>
      </div>
    </>
  );
}
